<template>
  <v-container
    fluid>
    <v-row>
      <v-col
        cols="12">
        <v-data-table
          id="IntegratorMovementsTable"
          class="default-table-height elevation-1"
          :headers="headers"
          :items="integratorMovements"
          :loading="loadIntegratorMovements"
          :server-items-length="totalElements"
          :options.sync="options"
          :items-per-page="integratorMovementFilter.size"
          :page="integratorMovementFilter.page"
          disable-sort
          :footer-props="{
            itemsPerPageOptions: [25, 50, 75, 100],
            disablePagination: loadIntegratorMovements,
          }"
          @update:options="changePage($event)">
          <!-- Cabeçalho -->
          <template
            v-slot:[`header.originMovementId`]>
            <TwoLineCell
              firstLine="Protocolo"
              :firstLineClass="headerFirstLine.class"
              :firstLineStyle="headerFirstLine.style"
              secondLine="Origem"
              :secondLineClass="headerSecondLine.class"
              :secondLineStyle="headerSecondLine.style"
            />
          </template>
          <template
            v-slot:[`header.familySequenceCode`]>
            <TwoLineCell
              firstLine="Código Família"
              :firstLineClass="headerFirstLine.class"
              :firstLineStyle="headerFirstLine.style"
              secondLine="Código Sequencial"
              :secondLineClass="headerSecondLine.class"
              :secondLineStyle="headerSecondLine.style"
            />
          </template>
          <template
            v-slot:[`header.groupCarrier`]>
            <TwoLineCell
              firstLine="Grupo Financeiro"
              :firstLineClass="headerFirstLine.class"
              :firstLineStyle="headerFirstLine.style"
              secondLine="Operadora"
              :secondLineClass="headerSecondLine.class"
              :secondLineStyle="headerSecondLine.style"
            />
          </template>
          <template
            v-slot:[`header.policy`]>
            <TwoLineCell
              firstLine="Apólice"
              :firstLineClass="headerFirstLine.class"
              :firstLineStyle="headerFirstLine.style"
              secondLine="Subcontrato"
              :secondLineClass="headerSecondLine.class"
              :secondLineStyle="headerSecondLine.style"
            />
          </template>
          <template
            v-slot:[`header.nameDocument`]>
            <TwoLineCell
              firstLine="Nome do Beneficiário"
              :firstLineClass="headerFirstLine.class"
              :firstLineStyle="headerFirstLine.style"
              secondLine="CPF"
              :secondLineClass="headerSecondLine.class"
              :secondLineStyle="headerSecondLine.style"
            />
          </template>
          <template
            v-slot:[`header.movementType`]>
            <span
              :class="headerFirstLine.class"
              :style="headerFirstLine.style">
              Tipo de Movimentação
            </span>
          </template>
          <template
            v-slot:[`header.beneficiaryType`]>
            <span
              :class="headerFirstLine.class"
              :style="headerFirstLine.style">
              Tipo do Beneficiário
            </span>
          </template>
          <template
            v-slot:[`header.status`]>
            <span
              :class="headerFirstLine.class"
              :style="headerFirstLine.style">
              Status
            </span>
          </template>
          <template
            v-slot:[`header.actions`]>
            <span
              :class="headerFirstLine.class"
              :style="headerFirstLine.style">
              Ações
            </span>
          </template>

          <!-- Lista -->
          <template
            v-slot:[`item.originMovementId`]="{ item }">
            <TwoLineCell
              :firstLine="item.id"
              :firstLineClass="bodyFirstLine.class"
              :firstLineStyle="bodyFirstLine.style"
              :secondLine="getOriginNameById(item.origin)"
              :secondLineClass="bodySecondLine.class"
              :secondLineStyle="bodySecondLine.style"
            />
          </template>
          <template
            v-slot:[`item.familySequenceCode`]="{ item }">
            <TwoLineCell
              :firstLine="item.integradoraFamilyCode || '-'"
              :firstLineClass="bodyFirstLine.class"
              :firstLineStyle="bodyFirstLine.style"
              :secondLine="item.integradoraFamilyCodeSeq || '-'"
              :secondLineClass="bodySecondLine.class"
              :secondLineStyle="bodySecondLine.style"
            />
          </template>
          <template
            v-slot:[`item.groupCarrier`]="{ item }">
            <TwoLineCell
              :firstLine="item.financialGroupId ? formatter.capitalizeText(formatter.formatFinancialGroup(item.financialGroupId, financialGroups)) : '-'"
              :firstLineClass="bodyFirstLine.class"
              :firstLineStyle="bodyFirstLine.style"
              :secondLine="item.carrierId ? formatter.capitalizeText(getInsuranceCarrierNameById(item.carrierId)) : '-'"
              :secondLineClass="bodySecondLine.class"
              :secondLineStyle="bodySecondLine.style"
            />
          </template>
          <template
            v-slot:[`item.policy`]="{ item }">
            <span
              :class="bodyFirstLine.class"
              :style="bodyFirstLine.style">
              {{ benefitData(item) }}
            </span>
          </template>
          <template
            v-slot:[`item.nameDocument`]="{ item }">
            <div
              @click="showDetails(item)">
              <TwoLineCell
                :firstLine="formatter.capitalizeText(item.insuredName)"
                :firstLineClass="`${bodyFirstLine.class} text-decoration-underline`"
                :firstLineStyle="`${bodyFirstLine.style}; cursor: pointer;`"
                :secondLine="item.insuredDocumentNumber ? formatter.formatCpf(item.insuredDocumentNumber) : '-'"
                :secondLineClass="`${bodySecondLine.class} text-decoration-underline`"
                :secondLineStyle="`${bodySecondLine.style}; cursor: pointer;`"
              />
            </div>
          </template>
          <template
            v-slot:[`item.movementType`]="{ item }">
            <span
              :class="bodyFirstLine.class"
              :style="bodyFirstLine.style">
              {{ item.movementIntegradoraType ? getIntegratorTypeName(item.movementIntegradoraType) : '-' }}
            </span>
          </template>
          <template
            v-slot:[`item.beneficiaryType`]="{ item }">
            <span
              :class="bodyFirstLine.class"
              :style="bodyFirstLine.style">
              {{ item.beneficiaryType ? formatter.formatBeneficiary(item.beneficiaryType) : '-' }}
            </span>
          </template>
          <template
            v-slot:[`item.status`]="{ item }">
            <v-sheet
              dense
              rounded="lg"
              color="muted-foreground"
              width="180"
              class="d-flex align-center justify-center pa-1 text-center">
              <span
                :class="`${bodyFirstLine.class} font-weight-medium`"
                :style="bodyFirstLine.style">
                {{ getIntegratorStatusName(item.status) }}
              </span>
              <v-icon
                class="ml-2"
                color="warning"
                size="14"
                v-if="item.status === 'INTEGRATION_ERROR'">
                fas fa-exclamation-triangle
              </v-icon>
            </v-sheet>
          </template>
          <template
            v-slot:[`item.actions`]="{ item }">
            <v-menu
              transition="slide-y-transition"
              offset-y>
              <template
                v-slot:activator="{ on, attrs }">
                <v-btn
                  class="base-color"
                  icon
                  v-bind="attrs"
                  v-on="on">
                  <v-icon>
                    mdi-dots-vertical
                  </v-icon>
                </v-btn>
              </template>
              <TodoListActions
                :actions="actions(item)"
              />
            </v-menu>
          </template>
        </v-data-table>

        <v-overlay :value="loadIntegratorMovements">
          <v-progress-circular indeterminate size="120">
            <div>Carregando...</div>
          </v-progress-circular>
        </v-overlay>

        <IntegratorMovementDetailModal
          ref="IntegratorMovementDetailModal"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import IntegratorMovementDetailModal from '@/components/Modals/IntegratorMovementDetailModal/IntegratorMovementDetailModal.vue';
import AuthorityManagementMixin from '@/shared/mixins/authorityManagement/authorityManagementMixin';
import IntegratorMovementsMixin from '@/shared/mixins/integratorMovements/IntegratorMovementsMixin';
import GenericFunctionsMixin from '@/shared/mixins/genericFunctions/genericFunctionsMixin';
import movementRecordsMixin from '@/shared/mixins/movementRecords/movementRecordsMixin';
import VerifyRoutesMixin from '@/shared/mixins/routeManagement/verifyRoutesMixin';
import InsuranceCarriersMixin from '@/shared/mixins/sdi/insuranceCarriersMixin';
import MovementRecordService from '@/services-http/sdi/MovementRecordService';
import TwoLineCell from '@/components/Default/TwoLineCell.vue';
import TodoListActions from '@/components/TodoList/TodoListActions.vue';
import ContractsMixin from '@/shared/mixins/sdi/contractsMixin';
import Formatters from '@/shared/formatters/formatters';
import Rules from '@/shared/validators/formRules';
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
  name: 'IntegratorMovementsTable',

  components: {
    IntegratorMovementDetailModal,
    TodoListActions,
    TwoLineCell,
  },

  data: () => ({
    kinships: [],
    options: {},
    skipInitialOptions: true,
    headers: [
      { value: 'originMovementId' },
      { value: 'familySequenceCode' },
      { value: 'groupCarrier' },
      { value: 'policy' },
      { value: 'nameDocument' },
      { value: 'movementType' },
      { value: 'beneficiaryType' },
      { value: 'status' },
      { value: 'actions' },
    ],
  }),

  props: {
    insuranceCarriers: {
      type: Array,
      default: () => [],
    },
    financialGroups: {
      type: Array,
      default: () => [],
    },
    isRHProtegido: {
      type: Boolean,
    },
  },

  mixins: [
    IntegratorMovementsMixin,
    AuthorityManagementMixin,
    InsuranceCarriersMixin,
    GenericFunctionsMixin,
    movementRecordsMixin,
    VerifyRoutesMixin,
    ContractsMixin,
  ],

  async created() {
    this.beginSearchLoading();
    this.movementRecordService = new MovementRecordService();
    this.formatter = new Formatters();
    this.rule = new Rules();
  },

  async mounted() {
    await this.loadBenefitTypes();
  },

  methods: {
    ...mapActions({
      setIntegratorMovementFilter: 'integrator-movement/setFilter',
      resendIntegratorMovement: 'integrator-movement/resend',
      fetchIntegratorMovements: 'integrator-movement/search',
    }),
    ...mapMutations({
      setIntegratorLoading: 'integrator-movement/loadingPage',
    }),
    beginSearchLoading() {
      this.setIntegratorLoading(true);
    },
    actions(integratorMovement) {
      const actions = [
        {
          label: 'Reenviar',
          icon: 'fas fa-redo-alt',
          color: 'primary',
          size: '25',
          condition: this.hasPermission('sdi_aba_movimentacao_integradora_acao_reprocessar'),
          disabled: integratorMovement.status !== 'INTEGRATION_ERROR',
          handler: () => this.resend(integratorMovement),
        },
        {
          label: 'Visualizar Logs',
          icon: 'fas fa-database',
          color: 'primary',
          condition: this.hasPermission('sdi_aba_movimentacao_integradora_visualizar_log'),
          disabled: false,
          handler: () => this.viewLogs(integratorMovement),
        },
      ];

      actions.sort((a, b) => a.label.localeCompare(b.label));

      return actions;
    },
    showDetails(integratorMovement) {
      this.$refs.IntegratorMovementDetailModal.open(integratorMovement);
    },
    async resend(integratorMovement) {
      const successfullyResent = await this.resendIntegratorMovement(integratorMovement.id);

      if (successfullyResent) {
        this.$emit('showMessage', { type: 'success', message: 'Reenvio realizado com sucesso!' });

        await this.fetchIntegratorMovements();
        return;
      }

      this.$emit('showMessage', { type: 'error', message: 'Ocorreu um erro ao reenviar esta movimentação da integradora!' });
    },
    viewLogs(integratorMovement) {
      const { id } = integratorMovement;
      this.redirectRouter('ApiLog', { isRHProtegido: this.isRHProtegido }, { id: id });
    },
    changePage({itemsPerPage, page}) {
      if (this.skipInitialOptions) {
        this.skipInitialOptions = false;
        return;
      }

      this.setIntegratorMovementFilter({
        size: itemsPerPage,
        page: page,
      });
    },
  },

  computed: {
    ...mapGetters({
      integratorMovementFilter: 'integrator-movement/integratorMovementFilter',
      filterWithFilledFields: 'integrator-movement/filterWithFilledFields',
      integratorMovements: 'integrator-movement/integratorMovements',
      loadIntegratorMovements: 'integrator-movement/loadPage',
      totalElements: 'integrator-movement/totalElements',
    }),
  },
};
</script>

<style lang="scss">
#IntegratorMovementsTable {
  .v-data-table-header > tr > th > span {
    text-transform: none !important;
  }
  > .v-data-table__wrapper {
    > table {
      > .v-data-table-header {
        background-color: var(--v-muted-foreground-base) !important;
      }
    }
  }
}
</style>
